import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { Text, Title } from './../Typography';

export const Content = tw.div`
  flex
  flex-col
  h-full
  justify-center
`;

export const Super = tw(Text)`
  text-darkgray
  opacity-70
`;

export const StyledTitle = tw(Title)`
  w-4/5		
  md:w-full
  sm:mt-px
  md:mt-2.5
  sm:mb-5	
  md:mb-30
  text-gray-300
`;

export const SocialContainer = tw.div<{ $isTwoColumns: boolean }>`
  grid
  grid-cols-1
  ${(p: { $isTwoColumns: boolean }) =>
    p.$isTwoColumns
      ? `
      md:grid-cols-2
    `
      : ''}
`;

export const SocialShare = tw.a`
  flex
  items-center
  text-darkgray
  mb-4
`;

export const SocialIconContainer = tw.div<{ $isSmall: boolean }>`
  mr-4
  ${(p: { $isSmall: boolean }) =>
    p.$isSmall
      ? `
    w-4.5
    h-4.5
  `
      : `
    w-30
    h-30
    md:w-10
    md:h-10
  `}
`;

export const SocialIcon = tw.img`
  object-contain
`;